import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("p", null, "导出正在进行中...", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_oio_button = _resolveComponent("oio-button")!
  const _component_el_progress = _resolveComponent("el-progress")!
  const _component_oio_modal = _resolveComponent("oio-modal")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_oio_button, {
      class: "oio-action-item",
      size: "small",
      onClick: _ctx.submit
    }, {
      default: _withCtx(() => [
        _createTextVNode(" 同步导出 ")
      ]),
      _: 1
    }, 8, ["onClick"]),
    _createVNode(_component_oio_modal, {
      visible: _ctx.visible,
      "onUpdate:visible": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.visible) = $event)),
      title: "导出进度",
      width: "small"
    }, {
      footer: _withCtx(() => [
        _createVNode(_component_oio_button, {
          type: "primary",
          onClick: _ctx.cancel
        }, {
          default: _withCtx(() => [
            _createTextVNode("确定")
          ]),
          _: 1
        }, 8, ["onClick"])
      ]),
      default: _withCtx(() => [
        _hoisted_1,
        _createVNode(_component_el_progress, {
          percentage: _ctx.percentage,
          "stroke-width": 12,
          striped: "",
          "striped-flow": "",
          status: _ctx.percentage === 100 ? 'success' : 'warning'
        }, null, 8, ["percentage", "status"])
      ]),
      _: 1
    }, 8, ["visible"])
  ], 64))
}